import { Navigate, useLocation } from "react-router-dom";
import { authRedirectTarget } from "utils/authLanguage";

const AuthLangRedirect = ({ basePath }) => {
  const location = useLocation();
  return <Navigate to={authRedirectTarget(basePath, location)} replace />;
};

export default AuthLangRedirect;
